import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { ActionSheetController, NavController } from '@ionic/angular';
import { ActionSheetButton } from '@ionic/core';
import { Router } from '@angular/router';
import { SlugifyPipe } from 'src/app/pipes/slugify.pipe';

@Component({
  selector: 'store-card-list',
  templateUrl: './store-card-list.component.html',
  styleUrls: ['./store-card-list.component.scss'],
})
export class StoreCardListComponent implements OnInit {
  tags: string;
  // imgDidLoad = false;
  imagePlaceholder = '../../../assets/icons/trvlx128.png';
  @Input() storeList: any;
  @Output() getNextPage = new EventEmitter<Event>();

  // tslint:disable-next-line: max-line-length
  constructor(private actionSheetController: ActionSheetController, private router: Router, private slugifyPipe: SlugifyPipe, private ngZone: NgZone, private navControl: NavController) {
  }

  ngOnInit() {
    // console.log('store-card ngOnInit');
  }

  async getLocationSheet(storeDetail: any) {
    const locationKeys = Object.keys(storeDetail.locationsMap);
    if (locationKeys.length === 1) {
      return this.navigateToNextPage(storeDetail, locationKeys[0]);
      // return this.navControl.navigateForward(['shopping/food', this.slugifyPipe.transform(storeName), id, { loc: locationKeys[0] }]);
      // return this.router.navigate(['shopping/food', this.slugifyPipe.transform(storeName), id, { loc: locationKeys[0] }]);
    }
    // tslint:disable-next-line: prefer-const
    let actionSheetButtonList: ActionSheetButton[] = [];
    actionSheetButtonList.push({
      text: 'Close',
      role: 'cancel',
    } as ActionSheetButton);
    if (storeDetail.locationsMap) {
      for (const key in storeDetail.locationsMap) {
        if (storeDetail.locationsMap.hasOwnProperty(key)) {
          const actionButton: ActionSheetButton = {
            text: storeDetail.locationsMap[key],
            handler: () => {
              // tslint:disable-next-line: max-line-length
              this.navigateToNextPage(storeDetail, key);
              // if (this.type === 'food') {
              //   this.navControl.navigateForward(['shopping/food/', this.slugifyPipe.transform(storeName), id, { loc: key }]);
              // } else {
              //   this.navControl.navigateForward(['shopping/retail/', this.slugifyPipe.transform(storeName), id, { loc: key }]);
              // }
              // this.ngZone.run(() => this.router.navigate(['shopping/food/', this.slugifyPipe.transform(storeName), id, { loc: key }]));
            }
          };
          actionSheetButtonList.push(actionButton);
        }
      }
    }
    const actionSheet = await this.actionSheetController.create({
      header: 'Select Location',
      // mode: 'ios',
      buttons: actionSheetButtonList
    });
    await actionSheet.present();
  }
  navigateToNextPage(storeDetail, key) {
    if (storeDetail.type === 1) {
      this.navControl.navigateForward(['shopping/food/', this.slugifyPipe.transform(storeDetail.storeName), storeDetail.id, { loc: key }]);
    } else if (storeDetail.type === 2 || 3) {
      this.navControl.navigateForward(['shopping/retail/', this.slugifyPipe.transform(storeDetail.storeName), storeDetail.id, { loc: key }]);
    }
  }
  showErrorImage() {
  }
  imageLoaded() {
  }
  getNextPageFromParent(event) {
    this.getNextPage.emit(event);
  }

}
